/**
 * @generated SignedSource<<1c1f824cb16a55c14933f75930a3af8c>>
 * @relayHash 0233a18a04c57e53ad9a43fcc32cffd8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/440.0.0-2023-11-22T16:45:05.822Z/editUserPreferencesMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditUserPreferencesInput = {
  auctionMailOptin?: boolean | null;
  clientMutationId?: string | null;
  communicationPreferredLocale?: string | null;
  customOffers?: boolean | null;
  emailConfirmed?: boolean | null;
  favoriteDealersMailList?: boolean | null;
  favoriteSearchesMailList?: boolean | null;
  orderFeedbackMailOptin?: boolean | null;
  promotionalMailList?: boolean | null;
  promotionalSmsOptin?: boolean | null;
  shareActivities?: boolean | null;
  smsOptin?: boolean | null;
  tradeMailList?: boolean | null;
  userId: string;
  weeklyDigestMailOptin?: boolean | null;
};
export type editUserPreferencesMutation$variables = {
  input: EditUserPreferencesInput;
};
export type editUserPreferencesMutation$data = {
  readonly editUserPreferences: {
    readonly user: {
      readonly preferences: {
        readonly shareActivities: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type editUserPreferencesMutation = {
  response: editUserPreferencesMutation$data;
  variables: editUserPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shareActivities",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "editUserPreferencesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditUserPreferencesPayload",
        "kind": "LinkedField",
        "name": "editUserPreferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editUserPreferencesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditUserPreferencesPayload",
        "kind": "LinkedField",
        "name": "editUserPreferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/440.0.0-2023-11-22T16:45:05.822Z/editUserPreferencesMutation",
    "metadata": {},
    "name": "editUserPreferencesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9bca29cf5d7e68a73a05b1fed8dc91c4";

export default node;
